import { Formik } from "formik";
import React from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Label,
    Row,
} from "reactstrap";


const ViewAccumulator = (props) => {
    const { accuData, toggle, toggle1 } = props;
    const handleCancel = () => {
        toggle();
    }
    const handleSubmit = async () => {
        toggle1();
    };

    return (
        <div>
            <Container>
                <Card>
                    <CardBody>
                        <h4 className="f-15 text-primary font-weight-700">
                            {" "}
                            View Accumulator{" "}
                        </h4>
                        <Formik
                            // initialValues={initialValues}
                            // onSubmit={handleSubmit}
                            // validationSchema={validationSchema}
                            // enableReinitialize={true}
                            children={(props) => {
                                // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                    <div hidden={""}>
                                        <Row sm={5}>
                                            <Col md="5" className="d-flex flex-wrap mt-2">
                                                <p className="m-0 f-14 mt-1">Accumulator Name : </p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.ceName}</p>
                                            </Col>
                                            <Col md="3" className='d-flex flex-wrap mt-2'>
                                                <p className="m-0 f-14 mt-1">OPA ID :</p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.opaCode}</p>
                                            </Col>
                                            <Col md="4" className='d-flex flex-wrap mt-2'>
                                                <p className="m-0 f-14 mt-1">Split Optimizer : </p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.lowestPriceCheckFlag === "Y" ? "Yes" : "No"}</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {accuData.lowestPriceCheckFlag === "Y" && accuData.gpoProhibitionFlag === "Y" && (
                                                <Col md="5" className="d-flex mt-2 align-items-center">
                                                    <p className="m-0 f-14 mt-1">Split Optimizer: Favors GPO : </p>
                                                    <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.accumulateToGPO === "Y" ? "Yes" : "No"}</p>
                                                </Col>)}
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                <p className="m-0 f-14 mt-1">HRSA Medicaid Billing :</p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.carveInFlag === "Y" ? "Carve-In" : "Carve-Out"}</p>
                                            </Col>
                                            <Col className="d-flex flex-wrap mt-2">
                                                <p className="m-0 f-14 mt-1">GPO Prohibition :</p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.gpoProhibitionFlag === "Y" ? "Yes" : "No"}</p>
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">

                                            <Col className="d-flex flex-wrap mt-2">
                                                <p className="m-0 f-14 mt-1">NDC to NDC Map :</p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.ndcAsCDMFlag === "Y" ? "Yes" : "No"}</p>
                                            </Col>
                                            <Col className="d-flex flex-wrap mt-2">
                                                <p className="m-0 f-14 mt-1">GCN Automapping :</p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{accuData.chargeAutomappingFlag === "Y" ? "Yes" : "No"}</p>
                                            </Col>
                                            <Col md="5" className="d-flex flex-wrap mt-2">
                                                <p className="m-0 f-14 mt-1">Payor Exclusions (Includes Out of State Medicaid) :</p>
                                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1"> {accuData.payorExclusionFlag === "Y" ? "Yes" : "No"}</p>
                                            </Col>
                                        </Row>

                                        <h4 className="f-15 text-primary font-weight-700 mt-4">
                                            Address Information{" "}
                                        </h4>

                                        <Row sm={5}>
                                            <Col md="4" className="d-flex flex-wrap mt-2">

                                                <p style={{ marginRight: "10px" }}>Contact Person :</p>
                                                <p>{accuData.contactPerson}</p>
                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}> Address 1 :</p>
                                                <p>{accuData.address1}</p>
                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Address 2 :</p>
                                                <p>{accuData.address2}</p>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>City :</p>
                                                <p>{accuData.cityName}</p>
                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>State :</p>
                                                <p>{accuData.stateID}</p>

                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Zip Code :</p>
                                                <p>{accuData.zipCode}</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Phone :</p>
                                                <p>{accuData.phone}</p>

                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Ext :</p>
                                                <p>{accuData.ext}</p>
                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Fax :</p>
                                                <p>{accuData.fax}</p>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Email ID :</p>
                                                <p>{accuData.emailID}</p>
                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">

                                                <p style={{ marginRight: "10px" }}>Website :</p>
                                                <p>{accuData.website}</p>

                                            </Col>
                                            <Col md="4" className="d-flex flex-wrap mt-2">
                                                {" "}
                                                <p style={{ marginRight: "10px" }}>Toll Free No :</p>
                                                <p>{accuData.tollFreeNo}</p>
                                            </Col>
                                        </Row>
                                        <Col className="pt-4 mt-1">
                                            <Label>{""}</Label>
                                            <Button
                                                style={{ float: "right" }}
                                                onClick={handleCancel}
                                                color="primary"
                                                className="ms-3"
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                style={{ float: "right" }}

                                                onClick={handleSubmit}
                                                color="primary"
                                                className="ms-3"
                                            // toggle = {toggle}
                                            // disabled={true}
                                            >
                                                EDIT
                                            </Button>
                                        </Col>
                                    </div>
                                );
                            }}
                        ></Formik>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default ViewAccumulator;
